/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Row, Col, Card, CardText, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import moment from 'moment';
import SubscribersBarChart from './SubscribersBarChart';

const SubscriberShowData = ({ dir, data, viewReportButton, title }) => {
    const thisMonthData = {};
    data.forEach((item) => {

        if (item.yearMonth && thisMonthData[item.yearMonth]) {
            thisMonthData[item.yearMonth].push(item)
        } else {
            thisMonthData[item.yearMonth] = [item]
        }

    })

    const reduceCallback = (acc, item) => acc + Number(item.noOfSubscriptions)
    const dataToPlot = []

    Object.keys((thisMonthData)).forEach((monthYear) => {
        const [year, month] = monthYear.split('-');
        const yearMonthStr = moment(monthYear).format('YYYY-MMM')
        const totalNoOfSubscriptions = thisMonthData?.[monthYear].reduce(reduceCallback, 0)
        dataToPlot.push({
            "date": yearMonthStr,
            'noOfSubscriptions': totalNoOfSubscriptions.toFixed(0),
        })
    })
    return (
        <Col xs="12">
            <Card className="pb-3 show-categ-daily-sales" >
                <div className="card__title row " style={{ position: 'relative' }}>
                    {title}
                    <div id="dvChartView">
                    {viewReportButton?.()}</div>
                </div>
                <div>
                    {data?.length ? (
                        <SubscribersBarChart
                            dataToPlot={dataToPlot}
                            height={400}
                            showTitle={false}
                            dir={dir}
                        />

                    ) : 'No data to display'}
                </div>
            </Card>
        </Col>

    )
}

SubscriberShowData.propTypes = {
    dir: PropTypes.string.isRequired,
    data: PropTypes.arrayOf({}).isRequired,
    title: PropTypes.string,
    viewReportButton: PropTypes.func.isRequired,
};

SubscriberShowData.defaultProps = {
    title: 'Subscribers',
}

export default SubscriberShowData;
